/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface ISetPropertyConfigurationScope extends angular.IScope {
        save: any;
        configuration: Wars.Domain.Model.Gis.SetPropertyConfiguration;
        inputCollection: Wars.Domain.Model.Gis.GisInputOutputCollection;
        mapConfiguration:Wars.Domain.Model.Gis.MapConfiguration;
        systemLevel:Wars.Domain.Model.SystemLevel;
    }

    export class SetPropertyConfiguration implements IDirective {
        public link($scope: ISetPropertyConfigurationScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/gis/setPropertyConfiguration.html";
        public restrict: string = "E";
        public controller = [
            "$scope", 'systemLevelService', SetPropertyConfigurationController
        ];
        public controllerAs = "controller";
        public scope: any = {
            configuration: "=",
            inputCollection: "=",
            mapConfiguration:"="
        };
    }

    export class SetPropertyConfigurationController {
        constructor(private $scope: ISetPropertyConfigurationScope,
            private systemLevelService: services.SystemLevelService) {
            systemLevelService.getSystemLevelJsonDictionaryStores().then(systemLevel => {
                $scope.systemLevel = systemLevel;
            });

            $scope.save = () =>systemLevelService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('SetPropertyConfiguration', []);